import script from "./CartComponentBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartComponentBase.vue?vue&type=script&setup=true&lang=ts"

import "./CartComponentBase.vue?vue&type=style&index=0&id=e86802c4&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e86802c4"]])

export default __exports__